((global) => {
  "use strict";
  const ATTRIBUTION_VERSION = "v2";
  const LINE_KEYS = Object.freeze([
    "_outfit_source_product_id",
    "_outfit_id",
    "_outfit_kind",
    "_outfit_surface",
  ]);
  const stringValue = (value) => (value == null ? "" : String(value));
  function lineHasCompleteAttribution(line) {
    return LINE_KEYS.every((key) => stringValue(line?.properties?.[key]));
  }
  function cartAttributionAttributes(items) {
    return {
      __outfit_used: Array.isArray(items) && items.some(lineHasCompleteAttribution) ? "true" : "false",
      __outfit_attribution_version: ATTRIBUTION_VERSION,
    };
  }
  const api = { ATTRIBUTION_VERSION, LINE_KEYS, cartAttributionAttributes, lineHasCompleteAttribution };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (!global || !global.document) return;
  const document = global.document;
  const ajaxRoute = (path) => `${global.Shopify?.routes?.root || "/"}${path}`;
  let inFlight = null;
  let subscribed = false;

  async function reconcileCartAttribution() {
    if (inFlight) return inFlight;
    inFlight = (async () => {
      const cartResponse = await global.fetch(ajaxRoute("cart.js"), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!cartResponse.ok) throw new Error("cart read failed");
      const cart = await cartResponse.json();
      const attributes = cartAttributionAttributes(cart.items);
      const updateResponse = await global.fetch(ajaxRoute("cart/update.js"), {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes }),
      });
      if (!updateResponse.ok) throw new Error("cart attribution update failed");
      return attributes;
    })();
    try {
      return await inFlight;
    } finally {
      inFlight = null;
    }
  }

  function subscribeToCartUpdates(attempt = 0) {
    if (subscribed) return;
    const subscriber = typeof subscribe === "function" ? subscribe : global.subscribe;
    const cartUpdate = typeof PUB_SUB_EVENTS !== "undefined"
      ? PUB_SUB_EVENTS.cartUpdate
      : global.PUB_SUB_EVENTS?.cartUpdate;
    if (typeof subscriber === "function" && cartUpdate) {
      subscriber(cartUpdate, () => reconcileCartAttribution().catch(() => null));
      subscribed = true;
      return;
    }
    if (attempt < 24) global.setTimeout(() => subscribeToCartUpdates(attempt + 1), 200);
  }

  document.addEventListener("submit", (event) => {
    if (!(event.target instanceof global.HTMLFormElement)) return;
    const form = event.target;
    const submitter = event.submitter;
    if (form.id !== "cart" || submitter?.name !== "checkout") return;
    if (form.dataset.outfitCheckoutReady === "true") {
      delete form.dataset.outfitCheckoutReady;
      return;
    }
    event.preventDefault();
    Promise.resolve(reconcileCartAttribution())
      .catch(() => null)
      .finally(() => {
        form.dataset.outfitCheckoutReady = "true";
        if (typeof form.requestSubmit === "function") form.requestSubmit(submitter);
        else form.submit();
      });
  }, true);

  reconcileCartAttribution().catch(() => null);
  subscribeToCartUpdates();
})(typeof window !== "undefined" ? window : globalThis);
